import {
  AxiosBookings,
  AxiosGLobalMessaging,
  AxiosMULEEX,
  AxiosMono,
  AxiosQUANTUM,
  userId,
  orgId,
} from "../apiConfig";
import { appendQueryParams } from "../../utilities/urlUtils";

import store from "../../store";

export const bookingsApiFactory = {
  $_getAllBookings(shippingServiceId = null) {
    let url = "";
    if (store.state.authentication.user.onboardingtype == "ondemand") {
      url = `/shippings`;
    } else {
      url = shippingServiceId
        ? `/shippings?shippingServiceId=${shippingServiceId}`
        : `/shippings/3PL/user`;
      `/shippings/3PL/${userId()}`;
    }
    return AxiosBookings.get(url);
  },
  $_getActiveBookings(params = {}) {
    const url = `/shippings/${userId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_searchBookings(searchTerm) {
    const url = `/shippings/searchUserShipmentsByOrg/${searchTerm}/${orgId()}`;
    return AxiosBookings.get(url);
  },
  $_getShipmentById(shipmentId) {
    const url = `/shippings/view/${shipmentId}`;
    return AxiosBookings.get(url);
  },
  $_processRequests(payload) {
    const url = `/requests`;
    return AxiosMULEEX.post(url, payload);
  },
  $_organizations() {
    const url = `/organizations`;
    return AxiosMULEEX.get(url);
  },
  $_requestByUserId(userId) {
    const url = `/requests/${userId}`;
    return AxiosMULEEX.get(url);
  },
  $_acknowledgeRequest(payload) {
    const url = `/token/verify`;

    return AxiosBookings.post(url, payload);
  },
  $_acknowledgeRequestMS(messageId, payload) {
    const url = `/messages/${messageId}`;
    return AxiosGLobalMessaging.patch(url, payload);
  },
  $_acknowledgeHandoff(payload) {
    const url = `requests/acknowledge-handoff`;
    return AxiosBookings.patch(url, payload);
  },
  $_getBookingByID(ID) {
    const url = `/shippings/${ID}?limitToUser = false`;
    return AxiosBookings.get(url);
  },
  $_updateShipping(shippingId, payload) {
    const url = `/shippings/${shippingId}`;
    return AxiosBookings.patch(url, payload);
  },
  $_getShippingsStatus() {
    const url = `/shippings/all-status`;
    return AxiosBookings.get(url);
  },
  $_getUserBookingByDate(start, end) {
    const url = `/shippings/findUserShippingsByDateRange/${start}/${end}`;
    return AxiosBookings.get(url);
  },
  $_estimateD(payload) {
    const url = "/payments/estimate";
    return AxiosBookings.post(url, payload);
  },
  $_getBookingAnalytics(params = {}) {
    const url = `/shippings/dashboard/states${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_getTerminals(payload) {
    const url = "/location/arrival-and-takeoff";
    return AxiosMULEEX.post(url, payload);
  },
  $_cancelBookings(bookingId, payload) {
    const url = `/shippings/updateShippingStatusByDriver/${bookingId}`;
    return AxiosBookings.patch(url, payload);
  },
  $_getSingleBooking(shipping1Id) {
    const url = `/shippings/${shipping1Id}`;
    return AxiosBookings.get(url);
  },
  $_submitShipperInformation(payload) {
    const url = "/locations/shipper-location";
    return AxiosBookings.post(url, payload);
  },
  $_submitConsigneeInformation(payload) {
    const url = "/locations/consignee-location";
    return AxiosBookings.post(url, payload);
  },
  $_submitPackageInformation(payload) {
    const url = "/packagees";
    return AxiosBookings.put(url, payload);
  },
  $_deletePackageInformation(id) {
    const url = `/packagees/${id}`;
    return AxiosBookings.delete(url);
  },
  $_getShippingInformation(shippingId) {
    const url = `/shippings/${shippingId}`;
    return AxiosBookings.get(url);
  },
  $_submitShippingInformation(payload, shippingId) {
    const url = `/shippings/${shippingId}`;
    return AxiosBookings.patch(url, payload);
  },
  $_submitPaymentInformation(payload) {
    const url = "/payments";
    return AxiosBookings.post(url, payload);
  },
  $_updateBookngLodation(payload) {
    const url = "/locations";
    return AxiosBookings.put(url, payload);
  },
  $_deleteShipping(shippingId) {
    const url = `/shippings/${shippingId}`;
    return AxiosBookings.delete(url);
  },
  $_getShippingServicesByRoute(pickupLocation, deliveryLocation) {
    const url = `/shippingservices/filter/${orgId()}?shipperLocationId=${pickupLocation}&consigneeLocationId=${deliveryLocation}&userType=3PL`;
    return AxiosBookings.get(url);
  },
  $_getShippingServiceFilter(params) {
    const url = `shippingservices/filter-by-terminal${appendQueryParams(
      params
    )}`;
    return AxiosBookings.get(url);
  },
  $_getShippingServiceById(shippingServiceId) {
    const url = `/shippingservices/${shippingServiceId}`;
    return AxiosBookings.get(url);
  },
  $_getShippingServiceByTerminal(dropOff, pickUp) {
    const url = `/shippingservices/filter-by-terminal?orgId=${orgId()}&userType=3PL&takeOffId=${dropOff}&arrivalId=${pickUp}`;

    return AxiosBookings.get(url);
  },
  $_serviceTerminals() {
    const url = `/shippingservices/terminal/all/${orgId()}`;
    return AxiosBookings.get(url);
  },
  $_createOndemandUser() {
    const user = JSON.parse(localStorage.getItem("loggedInUser"));
    const url = "/auth";
    const payload = {
      email: user.email,
      orgName: user.Orgs[0].companyname,
    };
    return AxiosBookings.post(url, payload);
  },
  $_getPaymentDetails(shippingId) {
    const url = `/shippings/view/${shippingId}`;
    return AxiosBookings.get(url);
  },
  $_initiateTransaction(payload) {
    const url = "/transactions";
    return AxiosBookings.post(url, payload);
  },
  $_updateTransaction(id, payload) {
    const url = `/transactions/${id}`;
    return AxiosBookings.patch(url, payload);
  },
  $_privateProcessReturn(id, payload) {
    const url = `/shippings/return-shipment/${id}/${userId()}`;
    return AxiosBookings.patch(url, payload);
  },
  $_createShippingId(payload) {
    const url = "/shippings";
    return AxiosBookings.put(url, payload);
  },
  $_updateShippingStatusByDriver(shippingId, payload) {
    const url = `/shippings/${shippingId}`;
    return AxiosBookings.patch(url, payload);
  },
  $_shippingActivityLogs(payload) {
    const url = `/shippingActivityLogs`;
    return AxiosBookings.post(url, payload);
  },
  $_getShippingTimeline(id) {
    const url = `/shippings/shippingTimeline/${id}`;
    return AxiosBookings.get(url);
  },
  $_getScheduledShippings() {
    const url = `/shippings/findShippingsByStatus/scheduled`;
    return AxiosBookings.get(url);
  },
  $_searchLocationByName(name) {
    const url = `/locations/search?name=${name}`;
    return AxiosBookings.get(url);
  },
  $_getBookings(params = {}) {
    const url = `/shippings/org/${orgId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_getBookingsByTerminal(terminalId, params = {}) {
    const url = `/terminal-shippings/${terminalId}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_getCostEngine(payload) {
    const url = "/cost-engine/";
    return AxiosBookings.post(url, payload);
  },
  $_getCostEngineByShipping(payload) {
    const url = "/cost-engine/by-shipping";
    return AxiosBookings.post(url, payload);
  },
  $_createTransaction(payload) {
    const url = "/transactions/";
    return AxiosBookings.post(url, payload);
  },
  $_getUserTotalShipping(params) {
    const url = `/shippings/findshippings/findUserShipmentHistoryInNumbers${appendQueryParams(
      params
    )}`;
    return AxiosBookings.get(url);
  },
  $_getDashboardOverview(userId) {
    const url = `/shippings/user/count/${userId}`;
    return AxiosBookings.get(url);
  },
  $_cancelShippment(bookingId, payload) {
    const url = `/shippings/${bookingId}`;
    return AxiosBookings.patch(url, payload);
  },
  $_updatePaymentStatus(payload, transactionId) {
    const url = `/transactions/v2/${transactionId}`;
    return AxiosBookings.patch(url, payload);
  },
  $_updateTransactionStatus(payload, transactionId) {
    const url = `/transactions/${transactionId}`;
    return AxiosBookings.patch(url, payload);
  },
  $_sharePayLink(shippingId) {
    const url = `/transactions/payment-details/${shippingId}`;
    return AxiosBookings.get(url);
  },
  $_getPaidtransactionValue(params) {
    const url = `/transactions/all/${userId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  newGetShippingServiceByRoute(params) {
    const url = `/shippingservices/filter-with-cost${appendQueryParams(
      params
    )}`;
    return AxiosBookings.get(url);
  },
  $_getStateNameWithDim(payload) {
    const url = `/shippingservices/get-state-name`;
    return AxiosBookings.post(url, payload);
  },
  $_getDispatcherDetails(id) {
    const url = `/users/${id}`;
    return AxiosBookings.get(url);
  },
  $_updateUserTransaction(id, payload) {
    const url = `/transactions/v2/${id}`;
    return AxiosBookings.patch(url, payload);
  },
  $_getBookingToplineAnalytics() {
    const url = `/shippings/analytics/${orgId()}`;
    return AxiosBookings.get(url);
  },
  $_getShippingTopRoutes() {
    const url = `/terminal-shippings/${orgId()}/toproutes`;
    return AxiosBookings.get(url);
  },
  $_getOutboundDispatcher() {
    const url = `/fleets/with-user/${orgId()}`;
    return AxiosBookings.get(url);
  },
  $_getUserPaymentSettings(userId) {
    const url = `payment-settings/${userId}`;
    return AxiosMULEEX.get(url);
  },
  $_getModulesNew() {
    let url = "/apps/muleex/privileges";
    return AxiosQUANTUM.get(url);
  },

  $_getEstimatedLocationTime(payload) {
    const url = `/trip/direction`;
    return AxiosMono.post(url, payload);
  },

  $_getVehicleWithCost(payload) {
    const url = `/trip/vehicles`;
    return AxiosMono.post(url, payload);
  },
  $_getTripsVehicles(payload){
    const url = `/trip/vehicles`;
    return AxiosMono.post(url, payload);
  },
  $_trackShipment(id) {
    let url = `/shippings/shippingTimeline/${id}`;
    return AxiosBookings.get(url);
  },
  $_submitRating(payload) {
    let url = `/rating`;
    return AxiosBookings.post(url, payload);
  },
  $_getRating() {
    let url = `/rating/${userId()}`;
    return AxiosBookings.get(url);
  },
  $_deleteQuote3pl(shippingId) {
    let url = `/shippings/${shippingId}`;
    return AxiosBookings.delete(url);
  },
  $_getDispatcherRating(params) {
    let url = `/rating/dispatcher-ratings/${userId()}${params}`;
    return AxiosBookings.get(url);
  },
  $_getDoorToDoorBooking(params) {
    let url = `/trip/bookings/${orgId()}${appendQueryParams(params)}`;
    return AxiosMono.get(url);
  },
  $_getUserRatingsHistory(params) {
    let url = `/rating/rating-history/${userId()}/${params}`;
    return AxiosBookings.get(url);
  },
   $_getUserPendingRatings(params) {
    let url = `/rating/pending-ratings/${userId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
   $_getDeliverySummary(shippingId) {
    let url = `/rating/delivery-summary/${shippingId}`;
    return AxiosBookings.get(url);
  },
  


  
  // this section is for the new booking flow integration
  $_createNewBooking(payload) {
    let url = `/booking/create`;
    return AxiosBookings.post(url, payload);
  },
  $_getCreatedNewBooking(id) {
    let url = `/booking/${id}`;
    return AxiosBookings.get(url);
  },
  $_updateNewTransactions(id, payload){
    let url = `/transactions/v2/${id}`;
    return AxiosBookings.patch(url, payload);
  },
  $_searchAddress(params){
    let url = `/booking/address${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
   $_getShippingService(params){
    let url = `/shippingservices/filter-with-cost-new${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  
};
